<template>
  <div>
    <header-nav ref="headerNav" :navList="navList"></header-nav>
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <other-icon></other-icon>
    <footer-nav ref="footerNav" :navList="navList"></footer-nav>
  </div>
</template>

<script>
import HeaderNav from "../components/HeaderNav.vue";
import FooterNav from "../components/FooterNav.vue";
import OtherIcon from "../components/OtherIcon.vue";
import { getNavListFunction } from "../api/home";
export default {
  components: {
    HeaderNav,
    FooterNav,
    OtherIcon
  },
  data() {
    return {
      navList: [],
    };
  },
  methods: {
    async fetchNav() {
      const res = await getNavListFunction();
      if (res.code !== 200) return false;
      // Keep existing CMS homepage links compatible without changing stored data.
      this.navList = res.data.map(item => ({
        ...item,
        path: item.path === '/home/page' ? '/' : item.path,
        link: item.link === '/home/page' ? '/' : item.link,
      }));
      localStorage.setItem('productList', JSON.stringify(this.navList[2].children))
    },
    updatePhoneBottomNav() {
      if (this.navList.length && document.documentElement.clientWidth < 768 && this.$refs.footerNav) {
        this.$refs.footerNav.showPhoneBottomNav(this.$route.name);
      }
    },
  },
  created() {
    this.fetchNav().then(this.updatePhoneBottomNav);
    window.addEventListener("resize", this.updatePhoneBottomNav);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updatePhoneBottomNav);
  },
  watch: {
    $route() {
      document.documentElement.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style>
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}

.fade-enter-active {
  transition: all 0.5s;
}

.fade-leave-active {
  transition: all 0.5s;
}
</style>
